// src/pages/Utilisateurs/UserListing.jsx
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../hooks/useScrollToTop";
import ScrollIndicator from "./../../hooks/ScrollIndicator";

import { useAdminUsersListing } from "./useAdminUsersListing";

import UsersAdminHeader from "./components/UsersAdminHeader";
import UsersFiltersBar from "./components/UsersFiltersBar";
import UsersPanel from "./components/UsersPanel";
import UserDrawer from "./components/UserDrawer";
import UserCompetitionDrawer from "./components/UserCompetitionDrawer";
import UsersPagination from "./components/UsersPagination";

const PAGE =
  "min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-50";

export default function UserListing() {
  useScrollToTop();

  const {
    filteredUsers,
    pageRows,
    roleOptions,
    rolesMap,
    competitionsMap,
    stats,

    loading,
    savingRoleId,
    deletingId,

    drawerMode,
    selectedUser,
    selectedCompetition,
    setSelectedCompetition,

    q,
    setQ,
    roleFilter,
    setRoleFilter,
    competitionFilter,
    setCompetitionFilter,
    sort,
    setSort,

    page,
    setPage,
    pageSize,
    setPageSize,
    pageCount,

    loadUsers,
    loadLatest,
    openAddDrawer,
    openEditDrawer,
    closeUserDrawer,
    saveUser,
    deleteUser,
    updateUserRole,
    exportCSV,
    resetFilters,
  } = useAdminUsersListing();

  return (
    <div className={PAGE}>
      <ScrollIndicator />

      <main className="mx-auto w-full max-w-[1280px] px-3 pb-12 pt-[120px] sm:px-5 md:pt-[145px]">
        <div className="space-y-6">
          <UsersAdminHeader
            stats={stats}
            roleOptions={roleOptions}
            loading={loading}
            onRefresh={loadUsers}
            onLatest={loadLatest}
            onAdd={openAddDrawer}
            onExport={exportCSV}
          />

          <UsersFiltersBar
            q={q}
            setQ={(value) => {
              setQ(value);
              setPage(1);
            }}
            roleFilter={roleFilter}
            setRoleFilter={(value) => {
              setRoleFilter(value);
              setPage(1);
            }}
            roleOptions={roleOptions}
            competitionFilter={competitionFilter}
            setCompetitionFilter={(value) => {
              setCompetitionFilter(value);
              setPage(1);
            }}
            sort={sort}
            setSort={(value) => {
              setSort(value);
              setPage(1);
            }}
            onResetFilters={resetFilters}
          />

          <UsersPanel
            rows={pageRows}
            loading={loading}
            searchTerm={q}
            rolesMap={rolesMap}
            roleOptions={roleOptions}
            competitionsMap={competitionsMap}
            savingRoleId={savingRoleId}
            deletingId={deletingId}
            onEdit={openEditDrawer}
            onDelete={deleteUser}
            onRoleChange={updateUserRole}
            onOpenCompetition={setSelectedCompetition}
          />

          <UsersPagination
            page={page}
            setPage={setPage}
            pageCount={pageCount}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={filteredUsers.length}
          />

          <div className="rounded-[24px] border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
            Total : <strong>{stats.total}</strong> • Affichés :{" "}
            <strong>{stats.filtered}</strong> • Avec compétitions :{" "}
            <strong>{stats.withCompetitions}</strong> • Sans compétition :{" "}
            <strong>{stats.withoutCompetitions}</strong>
          </div>
        </div>
      </main>

      <UserDrawer
        isOpen={Boolean(drawerMode)}
        mode={drawerMode}
        user={selectedUser}
        roleOptions={roleOptions}
        onClose={closeUserDrawer}
        onSubmit={saveUser}
      />

      <UserCompetitionDrawer
        competition={selectedCompetition}
        onClose={() => setSelectedCompetition(null)}
      />

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}